import { render } from "./PaymentStats.vue?vue&type=template&id=d952616a&scoped=true"
import script from "./PaymentStats.vue?vue&type=script&lang=js"
export * from "./PaymentStats.vue?vue&type=script&lang=js"

import "./PaymentStats.vue?vue&type=style&index=0&id=d952616a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d952616a"]])

export default __exports__